/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AckWhitelistItem = {
    samId?: string;
    sequenceNumber: number;
    result: AckWhitelistItem.result;
    error?: string;
    deviceId: string;
    deviceType: string;
};
export namespace AckWhitelistItem {
    export enum result {
        OK = 'Ok',
        CRC_ERR = 'CrcErr',
        DECODE_ERR = 'DecodeErr',
    }
}

